import React, { useMemo } from 'react';
import play from '../../Assets/play.png';
import './ClassOverview.css';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';

function ClassOverview({ video, classId, onEdit, onDelete }) {
  const navigate = useNavigate();

  const handleViewClass = () => {
    navigate(`/preview-class/${classId}`);
  };

   const thumbnailSrc = useMemo(() => {
     if (classId) {
       const newUrl = `https://beyondschools.co.tz:8443/api/Public/get-class-thumbnail/${classId}`;
       console.log('Using new URL format:', newUrl);
       return newUrl;
     }
   },);

  return (
    <div className="class-overview-container">
      <div
        className="class-overview-image"
        style={{ backgroundImage: `url(${thumbnailSrc})` }}
        onClick={handleViewClass}
      >
        <img src={play} alt="Play Icon" className="class-overview-play-toggle" />
      </div>
      <div className="class-overview-columns" onClick={handleViewClass}>
        <span className="class-overview-title-text">{video?.title || 'No Title'}</span>
        <div className="class-overview-row">
          <div className="class-overview-description">
            <span className='class-overview-sub'>Visibility: <span className="class-overview-user-text">{video?.status || 'Draft'}</span></span>
            <span className='class-overview-sub'>Views: <span className="class-overview-user-text">0 Students</span></span>
            <span className='class-overview-sub'>Watch Time: <span className="class-overview-user-text">0 Hours</span></span>
          </div>
          <div className="class-overview-description">
            <span className='class-overview-sub'>Completed: <span className="class-overview-user-text">0 Students</span></span>
            <span className='class-overview-sub'>Uncomplete: <span className="class-overview-user-text">0 Students</span></span>
          </div>
        </div>
      </div>

      <div className="class-overview-actions">
          <Button
            type="text"
            icon={<EditOutlined />}
            className="edit-draft-button"
            onClick={onEdit}
          />
        <Button
          type="text"
          icon={<DeleteOutlined />}
          className="delete-button"
          onClick={onDelete}
        />
      </div>
    </div>
  );
}

export default ClassOverview;